import { dicsQueryDics } from "@/api/index";
import store from "@/store/index.js";
import { queryDicItems } from '@/api/BSC';

/**
 * 1.判断对象是否为空
 * 2.判断字符串是否有值
 * @param o {Object}
 * @return 不为空返回true 为空返回false
 */
export const isNotEmpty = o => {
  if (o === "" || o === undefined || o === null) return false;

  if (typeof o == "String" && o.trim().length == 0) return false;

  return true;
};

/**
 * 将source和target共有属性，由source赋值至target
 * @param target {Object}
 * @param source {Object}
 * @param ignoreProperties {Array} 忽略的属性
 * @param isDeep {Boolean} 是否进行深层赋值
 */
export const mergeProperties = function(
  target,
  source,
  ignoreProperties,
  isDeep
) {
  if (!target || !source) return target;

  if (isDeep == null || isDeep == "undefined") isDeep = false;

  ignoreProperties = ignoreProperties || [];

  for (let i in target) {
    if (contains(ignoreProperties, i)) continue;

    if (i in source) {
      target[i] = source[i];
    } else if (typeof target[i] == "object" && isDeep) {
      mergeProperties(target[i], source, ignoreProperties, isDeep);
    }
  }
  return target;
};

/**
 * 将source属性及值复制至target
 * @param target {Object}
 * @param source {Object}
 * @param ignoreProperties {Array} 忽略的属性
 */
export const unionProperties = function(target, source, ignoreProperties) {
  if (!target || !source) return target;

  ignoreProperties = ignoreProperties || [];

  for (let i in source) {
    if (contains(ignoreProperties, i)) continue;

    target[i] = source[i];
  }

  return target;
};

/**
 * 判断数组是否包含指定元素
 * @param arr {Array}
 * @param obj {Object}
 */
export const contains = function(arr, obj) {
  let i = arr.length;
  while (i--) {
    if (arr[i] === obj) {
      return true;
    }
  }
  return false;
};

/**
 * 获取字典及转码通用方法
 * @param arr {Array} 字典配置
 * @param obj {Object} 转码对象,可以是数组或对象
 */
export const fetchDics = async function(dicConfig, obj) {
  if (!isNotEmpty(dicConfig)) {
    return;
  }

  let dicIds = [];
  for (let i = 0; i < dicConfig.length; i++) {
    if (dicConfig[i].force) {
      dicIds.push(dicConfig[i].id);
    } else if (!store.state.dicMap.has(dicConfig[i].id)) {
      dicIds.push(dicConfig[i].id);
    }
  }

  let dics = await dicsQueryDics(dicIds);
  for (let i in dics) {
    store.commit("MAPDICDATA", dics[i]);
  }

  if (obj) {
    dicFormatter(dicConfig, obj);
  }

  return dics;
};

/**
 * 获取单一字典方法
 * @param  dicId 字典ID
 * @param  force 是否强制刷新
 */
export const getDic = async function(dicId, force) {
  if (!store.state.dicMap.has(dicId)) {
    let o = {};
    o.id = dicId;
    o.force = force;
    await fetchDics([o]);
  }
  return store.state.dicMap.get(dicId);
};

/**
 * 转码通用方法
 * @param arr {Array} 字典配置
 * @param obj {Object} 转码对象,可以是数组或对象
 * @param isReverse {Boolean} 是否反转,默认fale
 */
export const dicFormatter = function(dicConfig, obj, isReverse) {
  if (obj instanceof Array) {
    for (let i = 0; i < obj.length; i++) {
      objFormatter(obj[i]);
    }
  } else if (obj instanceof Object) {
    objFormatter(obj);
  }

  function objFormatter(o) {
    dicConfig.forEach(element => {
      if (o.hasOwnProperty(element.property)) {
        let items = store.state.dicMap.get(element.id) || [];
        items.forEach(function(value, key, mapObj) {
          if (isReverse) {
            if (o[element.property] == value.dicItemName) {
              o[element.property] = value.dicItemCode + "";
            }
          } else {
            if (o[element.property] == value.dicItemCode) {
              o[element.property] = value.dicItemName;
            }
          }
        });
      }
    });
  }
};

//获取cookie、
export const getCookie = function(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return arr[2];
  else return null;
};

//设置cookie,增加到vue实例方便全局调用
export const setCookie = function(c_name, value, expireTimes) {
  var exdate = new Date();
  exdate.setTime(exdate.getTime() + expireTimes * 1000);
  var expires = "expires=" + exdate.toUTCString();
  document.cookie = c_name + "=" + escape(value) + ";expires=" + expires;
};

//删除cookie
export const delCookie = function(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toUTCString();
};



export const hasRights = btn => {
  let authSet = store.state["layoutStore"].authSet
  // 部分权限
  if (btn == '') {
    return true
  }
  for (let i = 0; i < authSet.length; i++) {
    if (btn == authSet[i]) {
      return true;
    }
  }
  return false
};
// 获取字典
// dicCode 字典类型   force 是否刷新字典，默认一直刷新请求字典
// 该方法会将已经获取的接口存在store,为了不频繁调用接口查字典，可以直接从store里面取,现在默认都是从接口取
export const getDicList = async (dicCode, force = true) => {

  let arr = [];
  let dicMap = store.state.dicMap;
  if (_.has(dicMap, dicCode) && dicMap[dicCode] && !force) {
    return dicMap[dicCode];
  }
  // 调用获取BSC字典的接口
  let res = await queryDicItems({ dicCode });
  if (res && res.length) {
    arr = res;
    store.commit('mapDicData', { dicCode: dicCode, dicItems: arr });
  }
  return arr; 
};